import cx from 'classnames'
import _ from 'lodash'
import { FORM_ERROR_CLASS_NAME } from '../../../../../styles/variables'
import CascaderWithSelectedPath from '../../../../Common/Cascader/CascaderWithSelectedPath'
import styles from './index.css'

const NewPathSelect = props => {
  const {
    // index,
    fieldPrefix,
    listing,
    value,
    options,
    currentPathOptions,
    change,
    updateMenuData,
    updateCategoryOptions,
    updateFormListingWithAttributes,
    triggerOptionLoadingState,
    isNeedSelectNewPath,
    isClusterDependOnCatItem,
    disabled
  } = props
  const {
    isInConsistentProduct
  } = listing

  const updateCurrentListing = listing => {
    // 有 prefix 代表示批次修改規格表
    // 因為有多個賣場指定其中一個更新所以需要 prefix 指定賣場再用 change 更新指定欄位
    // 沒有 prefix 時代表示修改賣場資訊，帶入 change 是 initialize
    // 因為一次更新整個賣場的 redux form 沒有帶欄位所以直接用 initialize
    if (_.isUndefined(fieldPrefix)) {
      change(listing)
      return
    }
    change(fieldPrefix, listing)
  }

  const loadMenuOptionsByLayerId = async (listing) => {
    const updatedListings = [listing]
    const updatedMenuData = await updateMenuData(updatedListings)
    updateCategoryOptions(updatedListings, updatedMenuData, false)
  }

  const loadData = async (currentSelectedOptions) => {
    const [catOption, catItemOption] = currentSelectedOptions
    const [catId, catItemId] = _.map(currentSelectedOptions, 'value')
    // 選擇子類
    if (!_.isUndefined(catItemId)) {
      triggerOptionLoadingState(listing, catOption, catItemOption)
      const newListing = { ...listing, catItemId }
      updateCurrentListing(newListing)
      await loadMenuOptionsByLayerId(newListing)
      return
    }

    // 選擇父類
    if (!_.isUndefined(catId)) {
      triggerOptionLoadingState(listing, catOption)
      const newListing = _.omit({ ...listing, catId }, ['catItemId'])
      updateCurrentListing(newListing)
      await loadMenuOptionsByLayerId(newListing)
    }
  }

  const onChange = async (currentSelectedValues) => {
    const [
      catId,
      catItemId,
      struDataAttrClusterId
    ] = currentSelectedValues
    if (_.isUndefined(struDataAttrClusterId)) {
      return
    }

    // 選擇規格
    const newListing = {
      ...listing,
      catId,
      catItemId,
      struDataAttrClusterId,
      isNewPathSelectable: true,
      isInConsistentProduct: false,
      // updateFormListingWithAttributes 指定此既有賣場的規格項目要用新選的規格表取代掉
      isReplaceAttributes: true
    }
    updateCurrentListing(newListing)
    const updatedListings = [newListing]
    const updatedMenuData = await updateMenuData(updatedListings)
    updateCategoryOptions(updatedListings, updatedMenuData)
    updateFormListingWithAttributes(updatedListings, updatedMenuData)
  }

  // 如果規格表選單選取不完整
  // 且規格項目不是從子類底下抓出來的，按照需求只顯示規格(不顯示父類、子類)
  const selectedPaths = (!isNeedSelectNewPath && !isClusterDependOnCatItem)
    ? [_.get(currentPathOptions, '2')]
    : currentPathOptions
  return (
    <div className={styles.CascaderWithSelectedPath}>
      <CascaderWithSelectedPath
        value={value}
        selectedPaths={selectedPaths}
        options={options}
        placeholder='-- 請選擇規格表 --'
        menuInputPlaceholder={['搜尋父類', '搜尋子類', '搜尋規格']}
        loadData={loadData}
        onChange={onChange}
        disabled={disabled}
      />
      {
        isNeedSelectNewPath && (
          <span
            className={cx(
              FORM_ERROR_CLASS_NAME,
              styles.newPathSelectError
            )}
          >
            {isInConsistentProduct ? '商品規格表不一致' : '規格表遺失'}
            ，請重新選擇規格表
          </span>
        )
      }
    </div>
  )
}

export default NewPathSelect
